import Vue from "vue";
import VueRouter from "vue-router";
import Employee from "../views/Employee/Employee.vue";

import Home from "../views/Employee/Home.vue";

import Report from "../views/Employee/Report.vue";
import ReportDetails from "../views/Employee/ReportDetails.vue";
import UpdateReport from "../views/Employee/UpdateReport.vue";
import ReportHistory from "../views/Employee/ReportHistory.vue";
import New from "../views/Employee/New.vue";
import NewReport from "../views/Employee/NewReport.vue";
import Validation from "../views/Employee/Validation.vue";

import HomeAdmin from "../views/Admin/HomeAdmin.vue";
import Periods from "../views/Admin/Periods.vue";
import Employees from "../views/Admin/Employees.vue";
import HcmcEmployees from "../views/Admin/HcmcEmployees.vue";
import HcmcViewers from "../views/Admin/HcmcViewers.vue";

import Hcmc from "../views/Hcmc/Hcmc.vue";
import HcmcHome from "../views/Hcmc/HcmcHome.vue";
import Pending from "../views/Hcmc/Pending.vue";
import PendingReports from "../views/Hcmc/PendingReports.vue";
import ViewPendingReport from "../views/Hcmc/ViewPendingReport.vue";
import PendingReportHistory from "../views/Hcmc/PendingReportHistory.vue";
import Submitted from "../views/Hcmc/Submitted.vue";
import SubmittedReports from "../views/Hcmc/SubmittedReports.vue";
import ViewSubmittedReport from "../views/Hcmc/ViewSubmittedReport.vue";

import Login from "../views/Login.vue";

import NewPass from "../views/NewPass.vue";
import store from "../store";

import Profile from "../views/Profile.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name != "NavigationDuplicated") {
      throw err;
    }
  });
};

const isAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next();
    return;
  }
  next("/login");
};

const isNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next();
    return;
  }
  next("/");
};

const isEmp = (to, from, next) => {
  if (store.getters.isLoggedIn && store.state.auth.userRole == "credit") {
    next();
    return;
  } else {
    next("/login");
  }
};

const isAdmin = (to, from, next) => {
  if (store.getters.isLoggedIn && store.state.auth.userRole == "admin") {
    next();
    return;
  } else {
    next("/login");
  }
};

const isHcmc = (to, from, next) => {
  if (
    store.getters.isLoggedIn &&
    (store.state.auth.userRole == "hcmc" ||
      store.state.auth.userRole == "viewer")
  ) {
    next();
    return;
  } else {
    next("/login");
  }
};

const userName = () => {
  if (store.state.auth.userRole == "credit") return "employees";
  else if (store.state.auth.userRole == "admin") return "admin";
  else if (
    store.state.auth.userRole == "hcmc" ||
    store.state.auth.userRole == "viewer"
  )
    return "hcmc";
  else return "/login";
};

const routes = [
  {
    path: "/login",
    component: Login,
    beforeEnter: isNotAuthenticated,
  },

  {
    path: "/newpass/:id",
    component: NewPass,
    beforeEnter: isNotAuthenticated,
  },

  {
    path: "/forgotpass",
    component: () => import("@/views/ForgotPassword"),
    beforeEnter: isNotAuthenticated,
  },

  {
    path: "/profile",
    component: Profile,
    beforeEnter: isAuthenticated,
  },

  {
    path: "/employees",
    component: Employee,
    beforeEnter: isEmp,
    children: [
      {
        path: "/",
        component: Home,
        beforeEnter: isAuthenticated,
      },
      {
        path: ":id/update_report",
        component: UpdateReport,
        beforeEnter: isAuthenticated,
      },
      {
        path: ":id/validation",
        component: Validation,
        beforeEnter: isAuthenticated,
      },

      {
        path: "new",
        component: New,
        beforeEnter: isAuthenticated,
        children: [
          {
            path: "report",
            component: NewReport,
          },
          {
            path: "validation",
            component: Validation,
          },
        ],
      },

      {
        path: "report",
        component: Report,
        children: [
          {
            path: ":id/details",
            component: ReportDetails,
          },
          {
            path: ":id/history",
            component: ReportHistory,
          },

          {
            path: ":id/validation",
            component: Validation,
          },
        ],
        beforeEnter: isAuthenticated,
      },
    ],
  },

  {
    path: "/admin",
    component: HomeAdmin,
    beforeEnter: isAdmin,
    children: [
      {
        path: "periods",
        component: Periods,
        beforeEnter: isAuthenticated,
      },
      {
        path: "employees",
        component: Employees,
        beforeEnter: isAuthenticated,
      },
      {
        path: "hcmcemployees",
        component: HcmcEmployees,
        beforeEnter: isAuthenticated,
      },
      {
        path: "hcmcviewer",
        component: HcmcViewers,
        beforeEnter: isAuthenticated,
      },
    ],
  },

  {
    path: "/hcmc",
    component: Hcmc,
    beforeEnter: isHcmc,
    children: [
      {
        path: "/",
        component: HcmcHome,
        beforeEnter: isAuthenticated,
      },

      {
        path: "pending",
        component: Pending,
        beforeEnter: isAuthenticated,
        children: [
          {
            path: "reports",
            component: PendingReports,
            beforeEnter: isAuthenticated,
          },
          {
            path: ":id/report",
            component: ViewPendingReport,
            beforeEnter: isAuthenticated,
          },
          {
            path: ":id/history",
            component: PendingReportHistory,
          },
        ],
      },
      {
        path: "submitted",
        component: Submitted,
        beforeEnter: isAuthenticated,
        children: [
          {
            path: "reports",
            component: SubmittedReports,
          },
          {
            path: "viewsubmittedreport",
            component: ViewSubmittedReport,
          },
        ],
      },
    ],
  },

  {
    path: "*",
    beforeEnter: isAuthenticated,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
